export default {
  slug: 'evidence',
  title: 'Evidence vault',
  description: 'Artifact intake, quarantine, and case linkage.',
  section: 'investigations',
  order: 3,
  tags: ['evidence', 'quarantine', 'artifacts'],
  body: `# Evidence vault

The **evidence vault** catalogs investigative artifacts with scan status, metadata, and case associations.

## Access

Open **[Investigations → Evidence](/evidence)** from the sidebar. New indicators can also be added via evidence workflows where configured.

## Evidence records

Each item typically includes:

- **Title** and **type** (screenshot, document, archive, etc.)
- **Scan status** — quarantine / analysis pipeline state
- **Collected timestamp** — with timezone toggle support platform-wide
- **Case linkage** — pivot from case Evidence tab

## Quarantine

Files land in the configured quarantine root (\`EVIDENCE_STORAGE_ROOT\` on the server). Do not bypass quarantine for untrusted uploads.

## Relationships

Evidence entities appear in relationship tables and the investigation graph (orange nodes). Link evidence to cases before external sharing so audit trails stay complete.

## Tips

- Prefer descriptive titles — they appear in relationship tables and graph labels.
- Cross-reference promoted indicators when IOCs are extracted from an artifact.
`,
};
